import { render, staticRenderFns } from "./tax-info.vue?vue&type=template&id=1972765a&scoped=true&"
import script from "./tax-info.vue?vue&type=script&lang=js&"
export * from "./tax-info.vue?vue&type=script&lang=js&"
import style0 from "./tax-info.vue?vue&type=style&index=0&id=1972765a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972765a",
  null
  
)

export default component.exports